const sliderItems = [
    {
        id: 0,
        name: "MD. KHALIL UDDIN",
        image: "slider-person-image s-p-i-1",
        position: "Head of Ideas"
    },
    {
        id: 1,
        name: "RUBEL MIAH",
        position: "Lead WordPress Developer",
        image: "slider-person-image s-p-i-2"
    },
    {
        id: 3,
        name: "SHAMIM MIA",
        position: "Sr Web Developer",
        image: "slider-person-image s-p-i-3"
    },
    {
        id: 4,
        name: "JOHN DOE",
        position: "Front-end Developer",
        image: "slider-person-image s-p-i-4"
    },
    {
        id: 5,
    },
]

export default sliderItems;